



















import { defineComponent } from '@vue/composition-api'
import QueryInput from '@/views/catalog/manageList/QueryInput.vue'
import ProductsFromCatalogStore from '@/store/productsList/productsFromCatalog'

export default defineComponent({
  name: 'PostListManage',
  components: {
      QueryInput,
  },
  data() {
    return {
      catalogId: 'not-set',
    }
  },
  mounted() {
  },
  created() {
  },
  computed: {
      getCatalogId(){
          return ProductsFromCatalogStore.state.catalogId
      }
  },
  watch: {
      getCatalogId() {
          if(ProductsFromCatalogStore.state.catalogId){
            this.getPostsData()
          }
      },
  },
  methods: {
    getPostsData() {
      ProductsFromCatalogStore.dispatch('getProductsFromCatalog')
    },
  },
})
